import { PANELMANAGER_HIDE_PANELPROPSDIALOG } from '../../constants';

export type HidePanelPropsDialogAction = {
    type: typeof PANELMANAGER_HIDE_PANELPROPSDIALOG;
    panelKey: string;
}

/**
 * @memberOf! Actions
 *
 * @param {String} panelKey
 *
 * @return {HidePanelPropsDialogAction}
 */
export default function hidePanelPropsDialog( panelKey: string ): HidePanelPropsDialogAction {
    return {
        type: PANELMANAGER_HIDE_PANELPROPSDIALOG,
        panelKey
    };
}
